import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { CNUser } from 'src/app/models/cnuser';

@Component({
  selector: 'app-user-group-list',
  templateUrl: './user-group-list.component.html',
  styleUrls: ['./user-group-list.component.scss']
})
export class UserGroupListComponent implements OnInit {

  @Output() selected: EventEmitter<CNUser> = new EventEmitter();
  @Input() groups: CNUser[] = [];
  public selectedGroup: CNUser;

  constructor() { }

  ngOnInit(): void {
  }

  public select(group: CNUser) {
    this.selectedGroup = group;
    this.selected.emit(group);
  }

}
